<template>

<div id="demo-card-analytics">

  <div class="vx-row mt-base">
    <div class="vx-col w-full lg:w-2/3 mb-base">
      <vx-card>
              <div class="con-tab-ejemplo">
                <vs-list>
                      <vs-list-header :title="grupo.clave"></vs-list-header>
                      <vs-list-item  v-for="alumno in grupo.alumnos" :title="alumno.nombre" :subtitle="alumno.nota">
                        <template slot="avatar" >
                          <vs-avatar :src="require(`@/assets/images/portrait/small/${ alumno.imagen }`)"  @click="popupActive=true"  />
                        </template>
                        <vs-checkbox color="success" />
                      </vs-list-item>
                    </vs-list>

              </div>

      </vx-card>
      </div>


    <div class="vx-col w-full lg:w-1/3 mb-base">
      <vx-card class="p-2">
        <div class="text-center">
          <h4><b>{{ asignatura }}</b></h4>
          <div >
            	<small class="date-label">Selecciona Fecha</small>
        <datepicker :name="end-date" v-model="end"></datepicker>
      </div>

        </div>
        <vs-avatar class="mx-auto my-6 block" size="80px" :src="require(`@/assets/images/portrait/small/${ card_5.userImg }`)" />
        <div class="flex justify-between text-center">
          <span>
            <p class="text-xl font-semibold">28</p>
            <small class="text-grey">Inscritos</small>
          </span>
          <span>
            <p class="text-xl font-semibold">24</p>
            <small class="text-grey">Asistentes</small>
          </span>
          <span>
            <p class="text-xl font-semibold">4</p>
            <small class="text-grey">Faltas</small>
          </span>
        </div>
        <vs-button  class="w-full mt-6" >Registrar Asistencia</vs-button>
      </vx-card>
    </div>



  </div>


  <!--Modal Detail-->
  <vs-popup class="" title="Agregar Justificante" :active.sync="popupActive">
    <div >
        <div class="vx-row">
          <vx-card>
            <div>
              <vs-textarea counter="1000" label="Escribe tus comentarios:" :counter-danger.sync="counterDanger" v-model="textarea" />
            </div>
            <div class="vx-row mb-6">

            </div>

            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full ml-auto">
                <vs-button class="mr-3 mb-2">Guardar</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
  </vs-popup>

</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
// import VueChartist from 'v-chartist';
import Datepicker from 'vuejs-datepicker';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  data() {
      return {
        start: '',
    end: '',
    desc: '',
    id: 0,
    textarea: '',
counterDanger: false,
    disabledFrom: false,
     popupActive:false,
        checked:true,
        unchecked:false,
        	colorx: 'success',
          asignatura:"Matemáticas I",
          grupo:{
                "clave":"Grupo DA434",
                "fecha":"06 Junio 2019",
                "alumnos":[{"nombre":"Diego Olvera","nota":" ",
                   "imagen":"avatar-s-7.png"},{"nombre":"Paola Rojas","nota":" ",
                   "imagen":"avatar-s-2.png"},{"nombre":"German Robles","nota":" ",
                   "imagen":"avatar-s-5.png"},{"nombre":"Mercedes Garcia","nota":"No asistió por tema familiar",
                   "imagen":"avatar-s-8.png"},{"nombre":"Armando Luna","nota":" ",
                   "imagen":"avatar-s-11.png"},{"nombre":"José Martínez","nota":" ",
                   "imagen":"avatar-s-15.png"},{"nombre":"Leticia Lopez","nota":" ",
                   "imagen":"avatar-s-14.png"}
                 ]

              },
          			// card 6
                card_5: {
                  userImg: 'clock.png',
                  name: 'Wilhelmina Jamal',
                  profession: 'Frontend Dev',
                  user_meta_1_title: 568,
                  user_meta_1_label: 'Uploads',
                  user_meta_2_title: '78.6K',
                  user_meta_2_label: 'Followers',
                  user_meta_3_title: 112,
                  user_meta_3_label: 'Following',
                  btn_text: 'Follow'
                }
      }
  },methods: {
				openNote(tipo){
              alert("metodo");
							this.activePopup = true;

		}
	},
  components: {
    Datepicker
  }
}
</script>


<style lang="scss">
#demo-card-analytics {
.tasks-today-container {
  .tasks-today__task {
    transition: background .15s ease-out;
    .tasks-today__actions {
      display: none;
    }

    &:hover {
      background: #f8f9ff;
      .tasks-today__actions {
        display: flex;
      }
    }
  }
}
}


</style>
